import { css } from '@emotion/core'
import { smallOnly, mediumOnly, mediumUp } from 'Utils'
import theme from 'Theme'

const { typography, colors, layout, mixins, spacing } = theme

const { mainContainerMaxWidth } = mixins

export default () => {
  const {
    maxWidth: { mainContainer, page: maxPageWidth }
  } = layout

  return css`
    max-width: 100%;
    width: 100%;
    min-height: 80vh;
    padding: 0;
    background-color: ${colors.trendBackground};

    .main-column__wrapper {
      ${mixins.defaultVerticalSpacing(theme)}
      background-color: white;
      @media ${mediumUp} {
        padding-left: calc(50% - ${mainContainer / 2}px);
      }
    }

    .main-wrapper__column-wrap {
      background-color: ${colors.bodyBackground};
    }

    .main-column {
      padding-top: ${spacing.vertical.medium};
      padding-bottom: ${spacing.vertical.large};
      max-width: 1400px;
      margin: 0 auto 0 auto;
    }

    .main-column__embed {
      max-width: 658px;
      margin-left: auto;
      margin-right: auto;
      @media ${smallOnly} {
        padding: ${spacing.vertical.small};
      }
      @media ${mediumOnly} {
        padding: ${spacing.vertical.medium};
      }
      @media ${mediumUp} {
        iframe {
          min-width: 500px;
          margin-left: auto !important;
          margin-right: auto !important;
        }
        .blockquote {
          min-width: 500px;
        }
      }
    }

    .main-column__category {
      text-align: center;
      padding-bottom: ${spacing.vertical.small};
    }

    .main-column__instalook-title {
      max-width: 700px;
      padding: 0 ${spacing.vertical.medium};
      margin-bottom: ${spacing.vertical.medium};
      margin-right: auto;
      margin-left: auto;
    }

    .main-column__instalook-title,
    .instalook-published {
      font-family: ${typography.headings.fontFamily};
    }

    .main-column__category {
      ${mixins.subText(theme)}
    }

    .instalook-published {
      ${mixins.defaultVerticalSpacing(theme)}
      h3 {
        font-size: ${typography.sizes.small};
        color: ${colors.secondary};
        font-weight: normal;
        text-align: center;
      }
    }

    .main-column__instalook-title {
      text-align: center;
      font-size: ${typography.sizes.xlarge};
      line-height: 1.2;
      font-weight: 700;
      color: ${colors.primary};
    }

    .products-column {
      width: 93%;
      max-width: ${maxPageWidth};
      margin: 0 auto;
      ${mixins.defaultVerticalSpacing(theme)};
      margin-top: ${spacing.vertical.large};
      background-color: ${colors.trendBackground};
    }

    @media ${smallOnly} {
      .article-target {
        width: 95%;
      }
    }

    .related {
      background-color: ${colors.bodyBackground};
      .article-list {
        ${mainContainerMaxWidth(theme)}
      }
    }

    .article-list__cta {
      padding-bottom: ${spacing.vertical.large};
    }
  `
}
